"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var LearningPathStore = /*#__PURE__*/function (_RootStore) {
  function LearningPathStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, LearningPathStore);
    _this = _callSuper(this, LearningPathStore);
    _this.config = {
      model: _models.LearningPath,
      deserialize: true,
      GET: {
        index: '/learning_paths',
        show: '/learning_paths/:learningPathId'
      },
      POST: {
        create: '/learning_paths'
      },
      PUT: {
        update: '/learning_paths/:learningPathId'
      },
      DELETE: {
        destroy: '/learning_paths/:learningPathId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(LearningPathStore, _RootStore);
  return (0, _createClass2["default"])(LearningPathStore);
}(_root_store["default"]);
var _default = exports["default"] = new LearningPathStore();